import { render, staticRenderFns } from "./MemberUpdateComponent.vue?vue&type=template&id=0638aa0a&"
import script from "./MemberUpdateComponent.vue?vue&type=script&lang=js&"
export * from "./MemberUpdateComponent.vue?vue&type=script&lang=js&"
import style0 from "./MemberUpdateComponent.vue?vue&type=style&index=0&id=0638aa0a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports